// Shared motion utilities and tokens

export const motion = {
  duration: {
    xs: 120,
    sm: 200,
    md: 320,
    lg: 450,
  },
  easing: {
    standard: 'cubic-bezier(0.2, 0.8, 0.2, 1)',
    entrance: 'cubic-bezier(0.16, 1, 0.3, 1)',
    exit: 'cubic-bezier(0.7, 0, 0.84, 0)',
  },
};

export const prefersReducedMotion = (): boolean => {
  if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};
